import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const DattaiKbn = props => {
  return <Dropdown.Static kubunKey='dattai_kbn' {...props} />
}
